// Components
import React from 'react';
import PropTypes from 'prop-types';
// Components
import Hero from '../components/Hero/Hero';
import MicroLayout from '../layouts/Micro';
import SEO from '../components/SEO/SEO';
import TagListItem from '../components/Tag/TagListItem/TagListItem';

const BlogCategories = ({ pageContext, location }) => {
  const categoryName =
    pageContext.categoryName?.charAt(0).toUpperCase() + pageContext.categoryName?.slice(1);

  const postsData = pageContext.allCategories?.filter((category) =>
    category.name.toLowerCase().includes(pageContext.categoryName.toLowerCase())
  )[0];

  return (
    <MicroLayout>
      <SEO title={categoryName} description={`${categoryName} tagged blog posts`} />

      <Hero
        title={categoryName}
        location={location}
        crumbLabel={categoryName}
        isNeedMainLabel={false}
      />

      <div className="container my-1">
        <div className="row flex-center">
          {postsData.posts &&
            postsData.posts.edges.map(({ node }) => (
              <TagListItem
                key={node.slug}
                fieldValue={node.title}
                image={node?.featuredImage?.node?.sourceUrl}
                excerpt={node.excerpt}
                url={`/blog${node.uri}`}
              />
            ))}
        </div>
      </div>
    </MicroLayout>
  );
};

BlogCategories.propTypes = {
  pageContext: PropTypes.object.isRequired, // eslint-disable-line
  location: PropTypes.objectOf.isRequired, // eslint-disable-line
};

export default BlogCategories;
